import React, { Component } from 'react';

import { connect } from 'react-redux';
import capitalize from 'capitalize';
import { browserHistory } from 'react-router';

import Toggle from 'material-ui/Toggle';
import FlatButton from 'material-ui/FlatButton';
import TextField from 'material-ui/TextField';
import IconButton from 'material-ui/IconButton';
import { MdDelete as DeleteIcon } from 'react-icons/md';

import * as landlordAPIDashboardActions from 'actions/landlordAPIDashboardActions';

import { colors } from 'helpers/ColorHelper';
import { AccentColor } from 'helpers/AccentColorHelper';

const style = {
  table_header: {
    margin: '30px 0px 10px 0px',
    backgroundColor: colors.LIGHT_GRAY,
  },
};

export default connect(
  (store) => {
    return {
      logos: store.landlordAPIDashboard.logos,
    };
  },
  (dispatch) => {
    return {
      getLogos: (mode) => {
        dispatch(landlordAPIDashboardActions.getLogos(mode));
      },
      deleteLogo: (mode, id) => {
        dispatch(landlordAPIDashboardActions.deleteLogo(mode, id));
      },
      clearLogos: (mode) => {
        dispatch(landlordAPIDashboardActions.displayLogos({ logos: null }));
      },
    };
  }
)(
  class Settings extends Component {
    constructor(props) {
      super(props);

      this.state = {
        mode: 'production',
        toggleLabel: 'Show Test Settings',
      };
    }

    UNSAFE_componentWillMount() {
      this.props.getLogos(this.state.mode);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      this.setState(
        {
          data: nextProps.logos,
        },
        () => this.forceUpdate()
      );
    }

    openAddAsset = () => {
      browserHistory.push(`/companies/api_dashboard_add_asset?mode=${this.state.mode}`);
    };

    updateFilter = (e, value) => {
      let mode = this.state.mode;
      let newMode = mode === 'production' ? 'test' : 'production';
      let newToggleLabel =
        newMode === 'production' ? 'Show Test Settings' : 'Showing Test Settings';

      this.setState({ mode: newMode });
      this.setState({ toggleLabel: newToggleLabel });
      this.props.getLogos(newMode);
    };

    render() {
      let assets;
      if (this.props.logos) {
        assets = this.props.logos.map((logo, index) => {
          return (
            <div className="row" style={{ marginTop: '15px' }}>
              <div className="col-sm-4">
                <TextField
                  name={logo.name}
                  value={logo.name}
                  type="text"
                  disabled={true}
                  floatingLabelText="Name"
                  style={{ marginTop: '-15px', fontSize: '14px', width: '100%' }}
                />
              </div>
              <div className="col-sm-4">
                <img
                  alt={'logo'}
                  width={'185px'}
                  color={'white'}
                  src={logo.url}
                  style={{ marginLeft: '60px', marginTop: '5px' }}
                />
              </div>
              <div className="col-sm-2">
                <IconButton
                  style={{
                    verticalAlign: 'top',
                    marginLeft: '100px',
                    marginTop: '10px',
                    width: '30px',
                  }}
                  onClick={() => this.props.deleteLogo(this.state.mode, logo.id)}
                >
                  <DeleteIcon size={24} style={{ padding: 0 }} />
                </IconButton>
              </div>
            </div>
          );
        });
      }

      const toggle = (
        <Toggle
          label={this.state.toggleLabel}
          labelPosition="right"
          style={{ marginTop: '10px' }}
          onToggle={this.updateFilter}
        />
      );

      return (
        <div className="body stage clearfix" role="main">
          <span className="page-title"> API Settings ({capitalize(this.state.mode)}) </span>
          {toggle}
          <div className="container application-container">
            <div className="row" style={style.table_header}>
              <div style={{ padding: '5px 10px 25px 15px' }}>
                <span style={{ textAlign: 'center', float: 'left' }}>Preferences</span>
              </div>
            </div>

            <div className="row" style={{ textAlign: 'center' }}>
              <div style={{ padding: '20px 0px' }}>
                <span style={{ textAlign: 'center', fontWeight: 'bold' }}>No Preferences</span>
              </div>
            </div>
            <div className="row" style={style.table_header}>
              <div style={{ padding: '5px 10px 25px 15px' }}>
                <span style={{ textAlign: 'center', float: 'left' }}>Assets</span>
              </div>
            </div>
            {assets}

            {(!assets || assets.length === 0) && (
              <div className="row" style={{ textAlign: 'center' }}>
                <div style={{ padding: '20px 0px' }}>
                  <span style={{ textAlign: 'center', fontWeight: 'bold' }}>No Assets</span>
                </div>
              </div>
            )}

            <FlatButton
              backgroundColor={AccentColor()}
              hoverColor="grey"
              style={{ color: 'white', margin: '25px auto 50px auto', display: 'block' }}
              label="Edit Assets"
              type="button"
              onClick={() => {
                this.openAddAsset();
              }}
            />
          </div>
        </div>
      );
    }
  }
);
